export default __webpack_public_path__ + "static/media/loginImg.f70c96ef.png";